import { UserApiUserLoginCodeRequest } from "../../openapi";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useLoginCodeMutation = () =>
  useBaseMutation({
    mutationFn: (req: UserApiUserLoginCodeRequest, config) =>
      appApiClient.userApi.userLoginCode(req, config),
  });
